import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManagement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "*Icons* / Nav",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 147",
			d: "M4.88335 5.18265L11.6333 3.11162C11.8723 3.03831 12.1277 3.03831 12.3666 3.11162L19.1166 5.18265C19.6416 5.34372 20 5.82854 20 6.37766V11.9991C20 17.7053 13.9201 20.3024 12.3609 20.8746C12.1262 20.9607 11.8737 20.9607 11.6391 20.8746C10.0799 20.3024 4 17.7053 4 11.9991V6.37766C4 5.82854 4.35838 5.34372 4.88335 5.18265Z",
			fill: "#ADC9FF"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M1.89354 3.00742C1.36344 3.16513 1 3.65245 1 4.20551V12.0005C1 19.7991 9.78354 23.2423 11.6528 23.8867C11.8823 23.9658 12.1177 23.9658 12.3471 23.8867C14.2164 23.2423 23 19.7991 23 12.0005V4.20551C23 3.65245 22.6365 3.16513 22.1064 3.00742L12.3564 0.10659C12.1238 0.0373867 11.8761 0.0373864 11.6435 0.10659L1.89354 3.00742ZM2.25 4.20551V12.0005C2.25 15.3716 4.13396 17.8581 6.39951 19.645C8.62009 21.3963 11.0722 22.3595 12 22.6841C12.9278 22.3595 15.3799 21.3963 17.6005 19.645C19.866 17.8581 21.75 15.3716 21.75 12.0005V4.20551L12 1.30469L2.25 4.20551Z",
					fill: "#2E2E2E"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.3666 3.11303C12.1277 3.03972 11.8723 3.03972 11.6333 3.11303L4.88334 5.18405C4.35837 5.34512 3.99999 5.82995 3.99999 6.37907V12.0005C3.99999 17.7067 10.0799 20.3038 11.6391 20.876C11.8737 20.9621 12.1262 20.9621 12.3609 20.876C13.9201 20.3038 20 17.7067 20 12.0005V6.37907C20 5.82995 19.6416 5.34513 19.1166 5.18405L12.3666 3.11303ZM12 4.30805L5.24999 6.37907L5.24999 12.0005C5.24999 14.3552 6.49008 16.1112 8.03672 17.4046C9.5451 18.666 11.2421 19.3928 12 19.6767C12.7579 19.3928 14.4549 18.666 15.9632 17.4046C17.5099 16.1112 18.75 14.3552 18.75 12.0005V6.37907L12 4.30805Z",
					fill: "#2E2E2E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9412 11.7656C13.5713 11.429 14 10.7648 14 10.0005C14 8.89597 13.1045 8.00054 12 8.00054C10.8954 8.00054 9.99997 8.89597 9.99997 10.0005C9.99997 10.7648 10.4287 11.429 11.0587 11.7656L10.1553 15.3793C10.0764 15.6948 10.3151 16.0005 10.6404 16.0005H13.3596C13.6849 16.0005 13.9235 15.6948 13.8447 15.3793L12.9412 11.7656Z",
					fill: "#2E2E2E"
				})
			]
		})]
	})
});
export { SvgManagement as ReactComponent };
